import { Campaign } from '../config/campaigns';
import { CampaignCard } from './CampaignCard';

interface CampaignGridProps {
    readonly campaigns: readonly Campaign[];
    readonly onDonate: (campaign: Campaign) => void;
    readonly onCreateClick: () => void;
    readonly loading?: boolean;
}

export function CampaignGrid({ campaigns, onDonate, onCreateClick, loading }: CampaignGridProps) {
    return (
        <section id="campaigns" className="section">
            <div className="container">
                <div className="section__header animate-on-scroll">
                    <span className="section__label">Campaigns</span>
                    <h2 className="section__title">Fund What Matters</h2>
                    <p className="section__desc">
                        Every satoshi goes directly to the campaign. Zero platform fees. 100%
                        transparent. Powered by OPNet smart contracts on Bitcoin L1.
                    </p>
                </div>

                <div className="campaigns-grid">
                    {/* Create Campaign Card - always first */}
                    <div
                        className="campaign-card"
                        style={{ cursor: 'pointer' }}
                        onClick={onCreateClick}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') onCreateClick();
                        }}
                    >
                        <div
                            className="campaign-card__image-placeholder"
                            style={{
                                background:
                                    'linear-gradient(135deg, var(--surface-overlay), var(--surface-interactive))',
                                border: '2px dashed var(--border-interactive)',
                                borderBottom: 'none',
                                borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0',
                            }}
                        >
                            <span style={{ fontSize: '3rem', opacity: 0.6 }}>+</span>
                        </div>
                        <div className="campaign-card__body" style={{ textAlign: 'center' }}>
                            <h3
                                className="campaign-card__title"
                                style={{ color: 'var(--accent-primary)' }}
                            >
                                + Create Campaign
                            </h3>
                            <p
                                className="campaign-card__desc"
                                style={{
                                    WebkitLineClamp: 'unset' as unknown as number,
                                }}
                            >
                                Start your own crowdfunding campaign on Bitcoin L1. Set a goal,
                                describe your idea, and let the community fund it.
                            </p>
                        </div>
                    </div>

                    {/* Campaign Cards */}
                    {campaigns.map((campaign) => (
                        <CampaignCard
                            key={campaign.id.toString()}
                            campaign={campaign}
                            onDonate={onDonate}
                        />
                    ))}
                </div>

                {loading && (
                    <div
                        style={{
                            textAlign: 'center',
                            padding: 'var(--space-xl) 0',
                            color: 'var(--text-muted)',
                        }}
                    >
                        <p style={{ fontSize: 'var(--font-size-sm)' }}>
                            Loading campaigns from chain...
                        </p>
                    </div>
                )}

                {!loading && campaigns.length === 0 && (
                    <div
                        className="animate-on-scroll"
                        style={{
                            textAlign: 'center',
                            padding: 'var(--space-3xl) 0',
                            color: 'var(--text-muted)',
                        }}
                    >
                        <p
                            style={{
                                fontSize: 'var(--font-size-lg)',
                                marginBottom: 'var(--space-sm)',
                            }}
                        >
                            No campaigns yet. Be the first!
                        </p>
                        <p style={{ fontSize: 'var(--font-size-sm)' }}>
                            Click &quot;+ Create Campaign&quot; above to get started.
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}
